import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';
import AsyncPage from './async';
import React from 'react';

export default [
  <ShowocaseLayout
    key="/business/showcase/watches"
    exact
    path="/business/showcase/watches"
    component={AsyncPage}
  />,
];
